import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-manager',
  templateUrl: './vehicle-manager.component.html',
  styleUrls: ['./vehicle-manager.component.scss']
})
export class VehicleManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
